import { AddressSettingsList } from "./AddressSettingsList";

export default AddressSettingsList;